export default "__VITE_ASSET__2ba26521__"